"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLookupMerging = exports.isLookupFieldType = exports.isLookupType = exports.isMergingLookupField = exports.getLookupMergeFieldFilter = exports.mergeLookupField = void 0;
var _mergeInputField = require("./mergeInputField.data");
var lookupType = _mergeInputField.dataTypes.lookupType,
  lookupFieldType = _mergeInputField.dataTypes.lookupFieldType;
var findMergingLookupIndex = function findMergingLookupIndex(_ref) {
  var value = _ref.value,
    currentCursorPosition = _ref.currentCursorPosition;
  return value.substring(0, currentCursorPosition).lastIndexOf('${');
};
var getLookupMergeFieldFilter = function getLookupMergeFieldFilter(_ref2) {
  var isMerging = _ref2.isMerging,
    value = _ref2.value,
    currentCursorPosition = _ref2.currentCursorPosition,
    selectedItem = _ref2.selectedItem;
  if (!isMerging) return value.substr(selectedItem.title.length + 1);
  var index = findMergingLookupIndex({
    value: value,
    currentCursorPosition: currentCursorPosition
  });
  return value.substring(index, currentCursorPosition).replace("${param:".concat(selectedItem.title, "."), '');
};
exports.getLookupMergeFieldFilter = getLookupMergeFieldFilter;
var mergeLookupField = function mergeLookupField(_ref3) {
  var value = _ref3.value,
    cursorPosition = _ref3.cursorPosition,
    highlightedItem = _ref3.highlightedItem;
  if (value.substring(cursorPosition - 2).includes('.}')) {
    var paramPart = value.substring(cursorPosition - 2).replace('.}', ".".concat(highlightedItem.title, "}"));
    return value.substring(0, cursorPosition - 2) + paramPart;
  }
  var index = value.substring(0, cursorPosition).lastIndexOf('.');
  var leftover = value.substring(index);
  return value.replace(leftover, ".".concat(highlightedItem.title, "}"));
};
exports.mergeLookupField = mergeLookupField;
var isMergingLookupField = function isMergingLookupField(_ref4) {
  var value = _ref4.value,
    currentCursorPosition = _ref4.currentCursorPosition,
    isLookupFieldSelected = _ref4.isLookupFieldSelected;
  return findMergingLookupIndex({
    value: value,
    currentCursorPosition: currentCursorPosition
  }) !== -1 && (value.substring(currentCursorPosition - 2).includes('.}') || !isLookupFieldSelected);
};
exports.isMergingLookupField = isMergingLookupField;
var isLookupType = function isLookupType(_ref5) {
  var type = _ref5.type;
  return type === lookupType;
};
exports.isLookupType = isLookupType;
var isLookupFieldType = function isLookupFieldType(_ref6) {
  var type = _ref6.type;
  return type === lookupFieldType;
};
exports.isLookupFieldType = isLookupFieldType;
var isLookupMerging = function isLookupMerging(_ref7) {
  var selectedItem = _ref7.selectedItem,
    prevSelectedItem = _ref7.prevSelectedItem,
    isMerging = _ref7.isMerging;
  return isMerging && selectedItem && (selectedItem && selectedItem.sourceType === lookupType || prevSelectedItem && prevSelectedItem.sourceType === lookupType);
};
exports.isLookupMerging = isLookupMerging;